const container = "_container_1e0uz_10";
const input = "_input_1e0uz_18";
const ui = "_ui_1e0uz_19";
const styles = {
  container,
  input,
  ui
};
export {
  container,
  styles as default,
  input,
  ui
};
//# sourceMappingURL=Radio.module.css.js.map
